import SliderVideos from "components/Slider/Videos";
import "./index.scss";

/**
 * Component: Recent
 *
 */
export default function Recent() {
  SliderVideos(".Recent:");
}
